import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducer';
import { composeWithDevTools } from 'redux-devtools-extension';

const initialState = {
	// intl: {
	// 	defaultLocale: 'en',
	// 	locale: 'fr',
	// 	messages: {}
	// }
};
const store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(thunk)));

export default store;



// WEBPACK FOOTER //
// ./src/store.js